import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-deviation-type-langs',
  templateUrl: './deviation-type-langs.component.html',
  styleUrls: ['./deviation-type-langs.component.css']
})
export class DeviationTypeLangsComponent implements OnInit {
    deviationTypeKeyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.deviationTypeKeyno = this.stateService.getStateParams()['deviationtype_keyno'];
    }

    private async loadLanguages() {
        if (!!this.deviationTypeKeyno) {
            this.inputListLanguages = await this.datatask.Post(1232, { deviationtype_keyno: this.deviationTypeKeyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(1233, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    deviationtype_keyno: string;
    deviationtypelang_name: string;
    language_id: string;
    language_name: string;
    orderby: string;
}
